import projectConfig from '@/config/config';
const baseURL = projectConfig.baseURL;
const api = {
  // 验证码发送
  loginSmsSend: baseURL + '/common/personal/login/sms/send',
  // 验证码登录
  loginSms: baseURL + '/common/personal/login/sms'
};

export default api;
